module.exports = __webpack_public_path__ + "img/hand.acbf6fbf.png";